<template>
  <div>
    <v-layout row wrap class="text-xs-center">
      <v-flex xs12 md12>
        <el-select
          size="small"
          v-model="selectedShopId"
          filterable
          placeholder="เลือกร้าน"
          class="mr-2"
        >
          <el-option
            v-for="item in shopList"
            :key="item.shop_id"
            :label="item.name"
            :value="item.shop_id"
          ></el-option>
        </el-select>

        <el-date-picker
          size="small"
          v-model="daterange"
          type="daterange"
          value-format="yyyy-MM-dd"
          format="dd/MM/yyyy"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
        ></el-date-picker>
        <el-button type="primary" class="ml-2" size="mini" @click="viewReport">ค้นหา</el-button>
        <!--
        <el-button type="primary" class="ml-2" size="mini" @click="downloadReport">ดาวน์โหลด</el-button>
        -->
      </v-flex>
    </v-layout>

    <v-layout class="my-4" v-if="showStat">
      <v-flex xs12 md12 class="pr-2">
        <el-card class="box-card">
          <v-layout>
            <v-flex class="text-xs-center">
              <strong>ยอดขาย</strong>
              <br />
              ฿ {{amount.revenue| numFormat('0,0.00')}}
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong>ค่าอาหาร</strong>
              <br />
              ฿ {{amount.food| numFormat('0,0.00')}}
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong>ค่าจัดส่ง</strong>
              <br />
              ฿ {{amount.delivery + amount.delivery_tax| numFormat('0,0.00')}}
              <span
                class="grey--text"
              >(฿ {{amount.lalamove| numFormat('0,0.00')}})</span>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong>จำนวนบิล</strong>
              <br />
              {{(amount.completed/orderList.length)*100| numFormat('0,0.00')}}%
              <span>({{amount.completed}}/{{orderList.length}})</span>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong>จำนวนสินค้า</strong>
              <br />
              {{amount.quantity| numFormat('0,0.00')}}
            </v-flex>
          </v-layout>
        </el-card>
      </v-flex>
    </v-layout>
    <el-card class="box-card mt-3">
      <div slot="header" class="clearfix">
        <span>&nbsp;</span>
        <el-button
          icon="fas fa-file-download"
          v-if="orderList.length>0"
          style="float: right; padding: 3px 0"
          type="text"
          @click="downloadReport"
        >&nbsp;ดาวน์โหลด</el-button>
      </div>

      <v-data-table
        :headers="headers"
        :items="orderList"
        :pagination.sync="pagination"
        :loading="isLoading"
        class="elevation-0"
      >
        <template v-slot:no-data>
          <div class="text-xs-center">
            <img src="../../assets/img/no-order.png" style="width:30%;" />
          </div>
        </template>

        <template v-slot:items="props">
          <tr>
            <td class="text-xs-center">
              <div>
                <el-tooltip
                  content="เดลิเวอรี่"
                  placement="top"
                  v-if="props.item.order_type=='delivery'"
                >
                  <i class="fas fa-motorcycle mr-2"></i>
                </el-tooltip>
                <el-tooltip
                  content="คอมเมิร์ซ"
                  placement="top"
                  v-if="props.item.order_type=='commerce'"
                >
                  <i class="fas fa-shopping-bag mr-2"></i>
                </el-tooltip>
                <el-tooltip
                  content="รับเองที่ร้าน"
                  placement="top"
                  v-if="props.item.order_type=='pickup'"
                >
                  <i class="fas fa-store mr-2"></i>
                </el-tooltip>
                <span class="grey--text">{{props.item.order_reference}}-</span>
                {{props.item.order_id | numFormat('00000')}}
              </div>
              <div
                v-if="props.item.status=='cancelled'"
                class="grey lighten-2 badge-status centered"
              >ยกเลิกแล้ว</div>
              <div
                v-if="props.item.status=='pending'"
                class="grey lighten-2 badge-status centered"
              >รอชำระเงิน</div>
              <div v-else-if="props.item.status=='new'" class="red badge-status centered">มาใหม่</div>
              <div
                v-if="props.item.status=='accepted' || props.item.status=='captured'"
                class="amber darken-1 badge-status centered"
              >ยืนยันแล้ว</div>
              <div
                v-if="props.item.status=='processing'"
                class="blue darken-2 badge-status centered"
              >ส่งให้ร้านแล้ว</div>
              <div
                v-if="props.item.status=='cooking'"
                class="blue darken-4 badge-status centered"
              >กำลังทำอาหาร</div>
              <div
                v-if="props.item.status=='completed'"
                class="green lighten-1 badge-status centered"
              >เรียบร้อยแล้ว</div>
            </td>
            <td class="text-xs-left">
              <el-button type="text" size="small" @click="openItem(props.item)">ดูรายละเอียด</el-button>
            </td>
            <td class="text-xs-left">
              <!-- เวลารับอาหาร -->
              <div style="width:150px;">
                <div>{{props.item.datetime_received| moment("DD/MM/YY HH:mm")}}</div>
                <div v-if="props.item.cluster_id!=null">
                  <el-tag
                    v-if="props.item.shop.cluster_json.find(x=>x.id==props.item.cluster_id)"
                    size="mini"
                    type="info"
                  >รอบส่ง {{props.item.shop.cluster_json.find(x=>x.id==props.item.cluster_id).delivery}}</el-tag>
                </div>
                <div v-if="props.item.driver_info_json!=null">
                  <a
                    v-if="props.item.driver_info_json.orderRef"
                    :href="`https://share.lalamove.com/?TH`+props.item.driver_info_json.orderRef+`&lang=th_TH`"
                    target="_blank"
                  >
                    <img src="../../assets/img/lalamove.png" style="width:40%;" />
                  </a>
                </div>
              </div>
            </td>
            <td class="text-xs-left">
              <!-- ข้อมูลลูกค้า -->
              <div style="width:120px;">
                <template v-if="props.item.user_ref_json!=null">
                  {{props.item.user_ref_json.firstname}} {{props.item.user_ref_json.lastname}}
                  <br />
                  <span class="font-xs">
                    <i class="fas fa-mobile-alt"></i>
                    {{props.item.user_ref_json.mobile}}
                  </span>
                </template>
              </div>
            </td>
            <td class="text-xs-left">
              <!-- เส้นทาง -->
              <div style="width:220px; padding:10px 0;">
                <ul
                  class="my-progress"
                  v-if="props.item.order_type=='delivery' || props.item.order_type=='commerce'"
                >
                  <li class="progress__item progress__item--completed">
                    <p class="progress__title">{{props.item.shop.name}}</p>
                  </li>
                  <li class="progress__item progress__item--active">
                    <p class="progress__title">
                      <span v-if="props.item.user_address">{{props.item.user_address.label}}</span>
                      <span>
                        {{props.item.user_address.place_detail.address}}
                        {{props.item.user_address.place_detail.sub_district}}
                        {{props.item.user_address.place_detail.district}}
                        {{props.item.user_address.place_detail.postcode}}
                      </span>
                    </p>
                  </li>
                </ul>
                <ul class="my-progress" v-if="props.item.order_type=='pickup'">
                  <li class="progress__item progress__item--completed">
                    <p class="progress__title">รับอาหารที่ร้าน {{props.item.shop.name}}</p>
                  </li>
                </ul>
                <!--
                <ul class="routes" v-if="props.item.order_type=='delivery'">
                  <li>{{props.item.shop.name}}</li>
                  <li>
                    <span
                      v-if="props.item.delivery_info_json.whereTo.address.text"
                    >{{props.item.delivery_info_json.whereTo.address.text}}</span>
                    <span v-else>{{props.item.delivery_info_json.whereTo.address}}</span>
                  </li>
                </ul>
                <div v-if="props.item.order_type=='pickup'">
                  <i class="fas fa-shopping-bag"></i>
                  รับอาหารที่ร้าน {{props.item.shop.name}}
                </div>
                -->
              </div>
            </td>
            <!-- จำนวนเงิน-->
            <td class="text-xs-left">
              <template>
                <strong>฿ {{props.item.amount.total | numFormat('0,0.00')}}</strong>
                <br />

                <span class="font-xs grey--text" v-if="props.item.payment_type=='transfer'">
                  โอนเงิน
                  <i
                    v-if="props.item.payment.payment_image_url!=null"
                    @click="viewSlip(props.item.payment.payment_image_url)"
                    class="far fa-file-image"
                  ></i>
                </span>
                <span class="font-xs grey--text" v-if="props.item.payment_type=='cash'">ชำระเงินสด</span>
                <span
                  class="font-xs grey--text"
                  v-if="props.item.payment_type=='creditcard'"
                >บัตรเครดิต</span>
              </template>
            </td>
          </tr>
        </template>
      </v-data-table>
    </el-card>
  </div>
</template>
<script>
import Service from "../../services";
import moment from "moment";
export default {
  components: {},
  props: { shop: { default: false }, showStat: { default: false } },
  data() {
    return {
      mode: null,
      loading: null,
      isLoading: false,
      daterange: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      selectedShopId: null,
      orderList: [],
      amount: {
        revenue: 0,
        delivery: 0,
        delivery_tax: 0,
        food: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        completed: 0,
        lalamove: 0,
      },
      statusOrder: ["new", "cooking", "processing", "completed", "cancelled"],
      permission: null,
      shopList: [],
      pagination: {
        rowsPerPage: -1,
      },
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "",
        },
        { text: "", value: "", sortable: false },
        { text: "เวลา", value: "", sortable: false },
        { text: "ข้อมูลลูกค้า", value: "", sortable: false },
        { text: "การจัดส่ง", value: "", sortable: false },
        { text: "จำนวนเงิน", value: "", sortable: false },
      ],
      statusOrder: [
        "pending",
        "new",
        "acccepted",
        "cooking",
        "processing",
        "completed",
        "cancelled",
      ],
    };
  },
  created() {
    Service.User.permission().then((resp) => {
      this.permission = resp.data;
      this.mode = this.permission.user.role_id;

      Service.Shop.gets().then((res) => {
        this.shopList = res.data.filter(function (item) {
          return ["published", "temp_close"].includes(item.status);
        });

        this.shopList.sort(function (a, b) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
        /*
        this.shopList = this.shopList.filter(item => {
          return item.ent_id == this.permission.enterprises[0].ent_id;
        });
        */
      });
    });
  },
  methods: {
    openItem(item) {
      if (item.order_type == "delivery" || item.order_type == "pickup") {
        this.$router.push("/view/order/" + item.order_reference);
      } else if (item.order_type == "commerce") {
        this.$router.push("/commerce/view/order/" + item.order_reference);
      }
    },
    viewReport() {
      this.showLoading();

      let params = {
        begin: this.daterange[0],
        end: this.daterange[1],
        report: true,
        type: "view",
      };

      if (this.selectedShopId != null) {
        params.shop_id = this.selectedShopId;
      }
      this.amount = {
        revenue: 0,
        delivery: 0,
        delivery_tax: 0,
        food: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        completed: 0,
        lalamove: 0,
      };
      Service.Report.get(params).then((res) => {
        this.orderList = res.data;

        this.orderList.sort(
          (a, b) =>
            this.statusOrder.indexOf(a.status) -
            this.statusOrder.indexOf(b.status)
        );

        this.orderList.map((item) => {
          if (item.status == "completed") {
            this.amount.revenue += parseFloat(item.amount.total);
            this.amount.delivery += parseFloat(item.amount.delivery);
            this.amount.delivery_tax += parseFloat(item.amount.delivery_tax);
            this.amount.food += parseFloat(item.amount.food);
            this.amount.extra += parseFloat(item.amount.extra);
            this.amount.discount += parseFloat(item.amount.discount);
            this.amount.completed++;

            let cog = 0;
            item.order_basket.product_list.map((product) => {
              cog += parseInt(product.cog) * product.quantity;
              this.amount.quantity += product.quantity;
            });
            item.amount.cog = cog;
            this.amount.cog += item.amount.cog;
            if (item.driver_info_json != null) {
              this.amount.lalamove +=
                parseFloat(item.amount.delivery) +
                parseFloat(item.amount.delivery_tax);
            }
          }
        });

        this.hideLoading();
      });
    },
    downloadReport() {
      this.showLoading();
      let params = {
        begin: this.daterange[0],
        end: this.daterange[1],
        report: true,
        type: "download",
      };

      if (this.selectedShopId != null) {
        params.shop_id = this.selectedShopId;
      }

      var queryString = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      let vuex = JSON.parse(localStorage.getItem("halalize"));
      let accessToken = vuex.Auth.accessToken;

      var request = new XMLHttpRequest();

      request.responseType = "blob";
      request.onreadystatechange = (e) => {
        let _ = this;
        let filename = "ยอดขายทั้งหมด_";
        if (this.selectedShopId != null) {
          let filename = _.shopList.find((x) => x.shop_id == _.selectedShopId)
            .name;
        }
        if (request.readyState !== 4) {
          return;
        }
        if (request.status === 200) {
          //console.log("success", request.response);
          var fileURL = window.URL.createObjectURL(
            new Blob([request.response], {
              type: "application/vnd.ms-excel",
            })
          );
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "sale_report_" + filename + ".xls");
          document.body.appendChild(fileLink);

          _.hideLoading();
          fileLink.click();
        } else {
          console.warn(request);
        }
      };

      request.onload = function (oEvent) {
        var blob = request.response;
      };

      request.open(
        "GET",
        "https://report-api.halalize.com/delivery/orders?" + queryString
      );
      request.setRequestHeader("Content-Type", "application/json");
      request.setRequestHeader("Authorization", "Bearer " + accessToken);
      //request.setRequestHeader("Accept", "*/*");
      //request.setRequestHeader("Origin", "dev-admin.foodhunt.com");
      //request.setRequestHeader("Host", "dev-order-api.foodhunt.com");
      request.send();
    },
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },
    hideLoading() {
      this.loading.close();
    },
  },
};
</script>